import React, { Component } from 'react';
import { connect } from 'react-redux';
import { QueryBuilder } from '../../components';
import {
  addQueryEntityRequest,
  updateQueryEntityInfos,
  deleteEntityRequest,
  clearQueryRequest,
  changeGroupOperatorRequest,
  moveEntityRequest,
  changeAudienceTimeframeRequest,
  changeResultTimeframeRequest,
  changeBaseQueryRequest,
  requestAudienceDetails,
  requestCreateAudience,
  itemDragToggle,
  itemDragDropped,
  addQueryAnItemWithInfos,
  showModal,
  getTaxonomyList,
  resetQueryError,
  changeQueryTypeRequest,
  addConversationItemRequest,
  moveConversationItemRequest,
  collapseRepository,
  resetConversationQueryError,
  initializeQueryBuilder,
} from '../../actions';

class QueryBuilderContainer extends Component {
  componentDidMount() {
    this.props.getTaxonomyList();
  }

  handleOnItemDragToggle = mode => {
    this.props.itemDragToggle(mode);
  };

  handleOnItemDropped = () => {
    this.props.itemDragDropped();
  };

  handleClearQueryRequest = () => {
    this.props.showModal(
      {
        isOpen: true,
        position: 'center',
        onConfirm: () => {
          const target = this.props.queryBuilder.target_selected;
          this.props.clearQueryRequest(target);
        },
      },
      'ClearQueryConfirm'
    );
  };

  handleOnMissingItemRequest = () => {
    this.props.showModal(
      {
        isOpen: true,
        position: 'center',
      },
      'RequireMissingItem'
    );
  };

  render() {
    const {
      conversation,
      itemDragDrop,
      createAudienceModal,
      initializeQueryBuilder,
      resetQueryError,
    } = this.props;

    const { isLoading } = createAudienceModal;

    return (
      <QueryBuilder
        conversation={conversation}
        isQueryCreationLoading={isLoading}
        entityDragging={itemDragDrop.elementDragging}
        clearQueryRequest={this.handleClearQueryRequest}
        onItemDragToggle={this.handleOnItemDragToggle}
        onItemDropped={this.handleOnItemDropped}
        onRequireMissingItemRequest={this.handleOnMissingItemRequest}
        onQueryErrorClose={resetQueryError}
        initializeQueryBuilder={initializeQueryBuilder}
      />
    );
  }
}

const mapDispatchToProps = {
  initializeQueryBuilder,
  addQueryEntityRequest,
  updateQueryEntityInfos,
  clearQueryRequest,
  deleteEntityRequest,
  changeGroupOperatorRequest,
  moveEntityRequest,
  changeAudienceTimeframeRequest,
  changeResultTimeframeRequest,
  changeBaseQueryRequest,
  requestAudienceDetails,
  requestCreateAudience,
  itemDragToggle,
  itemDragDropped,
  addQueryAnItemWithInfos,
  showModal,
  getTaxonomyList,
  resetQueryError,
  changeQueryTypeRequest,
  addConversationItemRequest,
  moveConversationItemRequest,
  collapseRepository,
  resetConversationQueryError,
};

const mapStateToProps = state => ({
  queryBuilder: state.queryBuilder,
  taxonomyList: state.taxonomyList,
  createAudienceModal: state.createAudienceModal,
  itemDragDrop: state.itemDragDrop,
  timeframes: state.timeframes,
  conversation: state.conversation,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QueryBuilderContainer);
